export default function throttle<T extends (...args: any[]) => any>(
  callback: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let last: number | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  return function (...args: Parameters<T>) {
    const now = +new Date();
    if (last && now < last + delay) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        callback(...args);
        last = now;
      }, delay);
    } else {
      callback(...args);
      last = now;
    }
  };
}
